module.exports = __webpack_public_path__ + "img/icon3.2c8a860b.png";